export default function initialize() {
  // load script
  !(function(w, d, i, s) {
    function l() {
      if (!d.getElementById(i)) {
        var f = d.getElementsByTagName(s)[0],
          e = d.createElement(s)
        ;(e.type = 'text/javascript'),
          (e.async = !0),
          (e.src = 'https://canny.io/sdk.js'),
          f.parentNode.insertBefore(e, f)
      }
    }
    if ('function' != typeof w.Canny) {
      var c = function() {
        c.q.push(arguments)
      }
      ;(c.q = []),
        (w.Canny = c),
        'complete' === d.readyState
          ? l()
          : w.attachEvent
          ? w.attachEvent('onload', l)
          : w.addEventListener('load', l, !1)
    }
  })(window, document, 'canny-jssdk', 'script')

  // identify canny user for tracking
  Canny('identify', {
    appID: '5d5d8089f6d07e70de8637a3',
    user: {
      // Replace these values with the current user's data
      email: user.email || `user-${user.id}@cannydedupebyid.com`,
      name: user.name,
      id: user.id,
      customFields: {
        role: user.role
      },
      companies: [
        {
          id: orgConfig.id,
          name: orgConfig.name
        }
      ]
    }
  })

  // load the change log with notification bell
  Canny('initChangelog', {
    appID: '5d5d8089f6d07e70de8637a3',
    position: 'bottom',
    align: 'right'
  })
}
